import { render, staticRenderFns } from "./MobileUserProfile.vue?vue&type=template&id=3bfdc347&scoped=true&"
import script from "./MobileUserProfile.vue?vue&type=script&lang=js&"
export * from "./MobileUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./MobileUserProfile.vue?vue&type=style&index=0&id=3bfdc347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfdc347",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
